import { useDisclosure } from "@chakra-ui/react";
import { useState } from "react";
import { object, string } from "yup";
import * as yup from "yup";

const useSimulatorsNewProduct = () => {
  const {
    isOpen: isOpenInfoForSimulation,
    onOpen: onOpenInfoForSimulation,
    onClose: onCloseInfoForSimulation,
  } = useDisclosure();
  const {
    isOpen: isOpenDescontoSimuladoNaoAprovado,
    onOpen: onOpenDescontoSimuladoNaoAprovado,
    onClose: onCloseDescontoSimuladoNaoAprovado,
  } = useDisclosure();
  const {
    isOpen: isOpenInfosAdicionais,
    onOpen: onOpenInfosAdicionais,
    onClose: onCloseInfosAdicionais,
  } = useDisclosure();

  const [initialValues, setinitialValues] = useState({
    fracionamento: false,
    descargaManual: false,
  });

  const validationInfoForSimulation = object({
    filialId: yup.number().notOneOf([0], "O campo Filial é obrigatório").required("O campo Filial é obrigatório"),
    grupoProdutoId: yup.number().notOneOf([0], "O campo Grupo de Produto é obrigatório").required("O campo Grupo de Produto é obrigatório"),
    produtoId: yup.number().notOneOf([0], "O campo Produto é obrigatório").required("O campo Produto é obrigatório"),
  });

  const [initialInfoForSimulation, setInitialInfoForSimulation] = useState({
    filialId: 0,
    grupoProdutoId: 0,
    produtoId: 0,
  });

  return {
    initialValues,
    isOpenInfoForSimulation,
    onOpenInfoForSimulation,
    onCloseInfoForSimulation,
    validationInfoForSimulation,
    initialInfoForSimulation,
    isOpenDescontoSimuladoNaoAprovado,
    onOpenDescontoSimuladoNaoAprovado,
    onCloseDescontoSimuladoNaoAprovado,
    isOpenInfosAdicionais,
    onOpenInfosAdicionais,
    onCloseInfosAdicionais,
  };
};

export default useSimulatorsNewProduct;
